import type { ComponentType } from "react";
import { blankWeddingData } from "../data/blank-wedding-data";
import { referenceWeddingData } from "../data/reference-wedding-data";
import { InvitationRenderer } from "../template/renderer/InvitationRenderer";
import type { SectionType, InvitationTheme } from "../types/template";
import type { WeddingData } from "../types/wedding";

export interface TemplateDefinition {
  id: string;
  name: string;
  description: string;
  thumbnail: string;
  version: string;
  renderer: ComponentType<React.ComponentProps<typeof InvitationRenderer>>;
  supportedSections: SectionType[];
  defaultSectionOrder: SectionType[];
  defaultTheme: InvitationTheme;
  blankData: WeddingData;
  referencePreviewData: WeddingData;
  createdAt: string;
  updatedAt: string;
  active: boolean;
}

const sectionOrder = blankWeddingData.sections.slice().sort((a, b) => a.order - b.order).map((section) => section.type);

export const classicRomanticTemplate: TemplateDefinition = {
  id: "classic-romantic",
  name: "Classic Romantic",
  description: "Warm editorial styling with layered photography, story timeline, gallery, RSVP, gifts, and wishes.",
  thumbnail: "/reference-assets/cover-closing.webp",
  version: "1.0.0",
  renderer: InvitationRenderer,
  supportedSections: sectionOrder,
  defaultSectionOrder: sectionOrder,
  defaultTheme: structuredClone(blankWeddingData.theme),
  blankData: blankWeddingData,
  referencePreviewData: referenceWeddingData,
  createdAt: "2026-08-02T00:00:00.000Z",
  updatedAt: "2026-08-02T00:00:00.000Z",
  active: true
};

export const templateRegistry = new Map<string, TemplateDefinition>([[classicRomanticTemplate.id, classicRomanticTemplate]]);

export function getTemplate(templateId: string) {
  return templateRegistry.get(templateId) || classicRomanticTemplate;
}
